import React from 'react';
import { Button, Table, Form, Segment, Divider, Loader } from 'semantic-ui-react';
import Modal from 'react-responsive-modal';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import {
    fetchCourses,
    fetchStudentSemesterInfo,
    fetchStudentStatuses,
    fetchStudentStatusesLookup
} from '../../StudentOverview/NextSemesterEnroll';
import SimpleTwoColumnTableRow from '../../../StudentPersonalInfo/SimpleTwoColumnTableRow';
import { fetchStudyType } from '../../../Lookups/util';


axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


export default class GradYearEnrollment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            semesterToEnroll: '',
            requiredEcts: '',
            acquiredEcts: '',
            courses: [],
            studyTypes: [],
            studyType: '',
            studentStatus: '',
            studentStatusesLookup: [],
            studentStatuses: [],
            studentStatusesOpt: [],

            loading: true,
            open: false,
            locked: false,
            graduated: false,
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.fetchAcademicYearOptions = this.fetchAcademicYearOptions.bind(this);
        this.enrollThirdCycleStudent = this.enrollThirdCycleStudent.bind(this);
        this.resetForm = this.resetForm.bind(this);
    }

    componentDidMount() {
        this.props.fetchStudentOptions();
        this.fetchAcademicYearOptions();
        axios.all([fetchStudyType(), fetchStudentStatuses(), fetchStudentStatusesLookup()])
            .then(axios.spread((typesRes, statusesRes, statusesLookupRes) => {
                const studyTypes = typesRes.data.map(el => ({
                    ...el, key: el.id, value: el, text: el.displayName
                }));

                const studentStatusesOpt = statusesRes.data.map(el => ({
                    key: el.id, value: el, text: el.name
                }));

                let studentStatuses = statusesRes.data.map(el => ({
                    ...el, key: el.id, value: el, text: el.name
                }));

                if (localStorage.getItem('activeRole').substr(0, 41) !== 'Studentska: Akademija scenskih umjetnosti') {
                    studentStatuses = studentStatuses.filter(el => el._key !== 'gap_year');
                }

                const studentStatusesLookup = statusesLookupRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));


                this.setState({
                    studentStatuses,
                    studyTypes,
                    studentStatusesOpt,
                    studentStatusesLookup
                });
            }))
            .catch(err => {
                console.log('Failed to fetch study types, student statuses or semester info...');
            });
    }

    fetchAcademicYearOptions() {
        // semester/by-academic-year/{academicYearId}
        axios.get('/academic-years/current-and-previous/')
            .then(res => {
                this.setState({
                    academicYearOptions: res.data.reverse().map(el => ({
                        ...el, key: el.id, value: el.id, text: el.name
                    }))
                });
            });
    }

    handleInputChange(event, { name, value }) {
        if (name === 'student') {
            const studentStudyProgramId = value.id;
            axios.all([fetchStudentSemesterInfo(studentStudyProgramId), fetchCourses(studentStudyProgramId)
            ])
                .then(axios.spread((infoRes, coursesRes) => {
                    this.setState({
                        semesterToEnroll: infoRes.data.semesterToEnroll !== null ? infoRes.data.semesterToEnroll.name : '',
                        requiredEcts: infoRes.data.requiredEcts !== null ? infoRes.data.requiredEcts : '',
                        acquiredEcts: infoRes.data.acquiredEcts !== null ? infoRes.data.acquiredEcts : '',
                        courses: coursesRes.data ? coursesRes.data : [],
                        locked: infoRes.data.locked,
                        graduated: infoRes.data.graduated,
                        loading: false,
                    });
                }))
                .catch(err => {
                    console.log('Failed to fetch study types, student statuses or semester info...');
                });
        }
        this.setState({
            [name]: value
        });
    }
    enrollThirdCycleStudent() {
        let obj = {
            id: this.state.student.id,
            optLock: this.state.student.optLock,
            gradAcademicYearStudyTypeId: this.state.studyTypeGrad.id,
            gradAcademicYearStudentStatusId: this.state.studentStatusGrad.id,
        };
        axios.put(`/students/enroll/grad-year/third-cycle-or-specialist/${this.state.academicYear}`, { ...obj })
            .then(res => {
                toast('Student je uspješno upisan u apsolventski staž.');
                this.setState({ open: false });
                this.resetForm();
            })
            .catch(err => {
                if (err.response.data === 'Student is already enrolled in this academic year!') {
                    toast('Student je već upisan u trenutnu akademsku godinu!');
                } else if (err.response.data === 'This student study program is already being changed!') {
                    toast('Student je već izmijenjen!');
                } else if (err.response.data === 'This student was already enrolled in grad year.') {
                    toast('Student je već upisan u apsolventski staž!');
                } else if (err.response.data === 'This student has graduated!') {
                    toast('Student je diplomirao!');
                } else if (err.response.data === 'Could not enroll passed student in grad year!') {
                    toast('Došlo je do greške! Student nije upisan u apsolventski staž.');
                } else {
                    toast('Došlo je do greške! Student nije upisan u apsolventski staž.');
                }
                this.setState({ open: false });
            });
    }

    resetForm() {
        this.setState({
            student: null,
            academicYear: null,
            studyTypeGrad: null,
            studentStatusGrad: null
        });
    }

    render() {
        const {
            open, acquiredEcts, courses, studyTypeGradErr, studentStatusGradErr, studentStatusGrad,
            studyTypeGrad, studentStatuses, studyTypes
        } = this.state;
        return (
            <div>
                <Modal
                    open={open}
                    onClose={() => this.setState({ open: false })}
                    center
                ><br />
                    <h2>Upis studenta u apsolventski staž</h2>
                    <Divider />
                    {this.state.loading ? <Segment color="blue" clearing>
                        <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>
                    </Segment> : <Segment color="blue" clearing>
                        <Table celled unstackable compact>
                            <Table.Header>
                                <Table.Row>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                <SimpleTwoColumnTableRow
                                    name="Broj ECTS bodova"
                                    keyName="acquiredEcts"
                                    value={this.state.acquiredEcts ? acquiredEcts : '0'}
                                />
                                <SimpleTwoColumnTableRow
                                    name="Student se upisuje u"
                                    keyName="semesterToEnroll"
                                    value={this.state.academicYear ? 'apsolventski staž ' + this.state.academicYearOptions.find(el => el.value === this.state.academicYear).text : ''}
                                />
                                <SimpleTwoColumnTableRow
                                    name="Status studenta"
                                    keyName="studentStatusGrad"
                                    value={studentStatusGrad ? studentStatuses.find(el => el.value === studentStatusGrad).text : ''}
                                />
                                <SimpleTwoColumnTableRow
                                    name="Tip studiranja"
                                    keyName="studyTypeGrad"
                                    value={studyTypeGrad ? studyTypes.find(el => el.value === studyTypeGrad).text : ''}
                                />
                                <SimpleTwoColumnTableRow
                                    name="Predmeti koje student prenosi"
                                    keyName="courses"
                                    value={courses.map(el => (<div>{el.courseName}<br /></div>))}
                                />
                            </Table.Body>
                        </Table>


                        <Button floated="right" color="blue" basic="true" onClick={() => this.setState({ open: false })}>Odustani</Button>
                        <Button floated="right" color="blue" onClick={this.enrollThirdCycleStudent}>Upiši studenta</Button>

                    </Segment>}
                </Modal>
                <Form>
                    <Form.Group widths="equal">
                        <Form.Field required error={this.state.studentErr}>
                            <label>Student</label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odabir studenta"
                                value={this.state.student}
                                onChange={this.handleInputChange}
                                name="student"
                                options={this.props.studentOptions}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                        <Form.Field required error={this.state.academicYearErr}>
                            <label>Akademska godina</label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odabir godine"
                                value={this.state.academicYear}
                                onChange={this.handleInputChange}
                                name="academicYear"
                                options={this.state.academicYearOptions}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                        <Form.Field required error={studyTypeGradErr}>
                            <label>Tip studiranja studenta</label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odabir tipa"
                                value={studyTypeGrad}
                                onChange={this.handleInputChange}
                                name="studyTypeGrad"
                                options={studyTypes}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                        <Form.Field required error={studentStatusGradErr}>
                            <label>Status studenta</label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odabir statusa"
                                value={studentStatusGrad}
                                onChange={this.handleInputChange}
                                name="studentStatusGrad"
                                options={studentStatuses}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                    </Form.Group>
                    <Button
                        floated="right"
                        color="blue"
                        onClick={() => {
                            if (this.state.student && this.state.academicYear && this.state.studyTypeGrad && this.state.studentStatusGrad) {
                                this.setState({ open: true });
                            } else toast('Niste unijeli sva obavezna polja!');
                        }}
                    >Upiši studenta</Button>
                    <br />
                    <br />
                </Form>
                <ToastContainer hideProgressBar />
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/StudentService/ThirdCycle/SemesterEnrollment/GradYearEnrollment.js